export const columns = () => [
    {
        label: "BUILDINGS",
        sorting: {},
    },
    {
        label: "ADDRESSES",
        align: "right",
    },
];
